<template>
  <div class="modal fade" :id="'addVariationAttributeModal' + id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="createValueAttributeData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="'createModalLabel' + id">{{$t('attribut.add_new_value')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <div class="col-md-12">
                <label for="">{{ $t('attribut.value') }} <span class="text-danger">*</span> </label>
                <input :id="'kt_tagify_add_value_' + id" class="form-control tagify " type="text"/>
                <small :id="'valueHelpBlock' + id" class="form-text text-muted"> {{$t('attribut.tag_input_text')}}   </small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
            <button type="submit" :id="'kt_submit_add_value' + id" class="btn btn-sm btn-primary fw-bolder">
              <span class="indicator-label">{{ $t('button.save') }}</span>
              <span class="indicator-progress">{{  $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    props: {
      id: {
        required: false,
        type: String,
        default: '1',
      },
      variation: [String]
    },

    data(){
      return {
        formCreateValueData: {
          id: null,
          value: []
        },
      }
    },

    mounted() {
      let modal = $('#addVariationAttributeModal' + this.id)

      modal.on('shown.bs.modal', () => {
        this.formCreateValueData.id = this.variation
      });

      modal.on('hidden.bs.modal', () => {
        this.formCreateValueData.id = null
      });

      this.tagifyAddValue()
    },

    methods: {

      ...mapActions('attributs', [
        'createValueAttribut',
      ]),

      async createValueAttributeData(){
        this.$loading('kt_submit_add_value' + this.id)

        try{
          let response = await this.createValueAttribut(this.formCreateValueData)
          this.isLoading = false
          window.toastr['success'](i18n.global.t('notification.variation_added'))

          this.$emit('variationAttributeCreated', response.data.attribut)
          $('#addVariationAttributeModal' + this.id).modal('toggle')
          this.formCreateValueData = {
            id: null,
            value: []
          }
          this.$stopLoading('kt_submit_add_value' + this.id)
        }catch(err){
          this.$stopLoading('kt_submit_add_value' + this.id)
        }
      },

      tagifyAddValue(){
        let eAddValue = document.getElementById("kt_tagify_add_value_" + this.id)
        this.value = new Tagify(eAddValue)
        this.value.on("invalid", function (e) {
          if(e.detail.data.__isValid == 'pattern mismatch'){
            window.toastr['error']('variation invalid')
          }
        })
            .on('add', () => {

              this.formCreateValueData.value = this.value.value.map(x => x.value)
            })
            .on("remove", () => {
              this.formCreateValueData.value = this.value.value.map(x => x.value)
            })
      },

    }
  }
</script>